import { Badge } from "@/components/ui/badge";
import { CONFIDENTIALITY_LABELS } from "@/lib/constants";

const STATUS_STYLES = {
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "En négociation": "bg-amber-50 text-amber-700 border-amber-200",
  Signé: "bg-[#0F172A] text-white border-[#0F172A]",
};

const CONF_STYLES = {
  Standard: "border-slate-200 text-slate-600",
  Confidentiel: "bg-slate-900 text-white border-slate-900",
  "Ultra-confidentiel": "bg-[#C6A87C] text-[#0F172A] border-[#C6A87C]",
};

const COMMISSION_STYLES = {
  Estimée: "border-slate-200 text-slate-600",
  Confirmée: "bg-amber-50 text-amber-700 border-amber-200",
  Facturée: "bg-blue-50 text-blue-700 border-blue-200",
  Payée: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function StatusBadge({ status, testid }) {
  return (
    <Badge variant="outline" className={`rounded-full font-medium ${STATUS_STYLES[status] || ""}`} data-testid={testid}>
      {status}
    </Badge>
  );
}

export function ConfBadge({ level, testid }) {
  return (
    <Badge variant="outline" className={`overline rounded-full border px-2.5 py-0.5 ${CONF_STYLES[level] || ""}`} data-testid={testid}>
      {CONFIDENTIALITY_LABELS[level] || level}
    </Badge>
  );
}

export function CommissionBadge({ status, testid }) {
  return (
    <Badge variant="outline" className={`rounded-full font-medium ${COMMISSION_STYLES[status] || ""}`} data-testid={testid}>
      {status}
    </Badge>
  );
}

export function ScoreRing({ score }) {
  const color = score >= 70 ? "#C6A87C" : score >= 40 ? "#64748B" : "#CBD5E1";
  const deg = (score / 100) * 360;
  return (
    <div
      className="relative flex h-14 w-14 items-center justify-center rounded-full"
      style={{ background: `conic-gradient(${color} ${deg}deg, #E2E8F0 0deg)` }}
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-sm font-bold text-[#0F172A]">
        {score}%
      </div>
    </div>
  );
}
